import React from 'react';
import { Button, Popconfirm } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { FJ511 } from '../../../services/j214Api';

interface Tab2Props {
  details: Partial<FJ511>[];
  isEditing: boolean;
  onAdd: () => void;
  onDelete: (idx: number) => void;
  onDetailChange: (idx: number, key: keyof FJ511, value: FJ511[keyof FJ511]) => void;
}

const Tab2Details: React.FC<Tab2Props> = ({ details, isEditing, onAdd, onDelete, onDetailChange }) => {
  return (
    <div className="j214-tab2">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <span style={{ fontWeight: 600, fontSize: 14 }}>採購明細 ({details.length} 筆)</span>
        {isEditing && (
          <Button type="primary" size="small" icon={<PlusOutlined />} onClick={onAdd}>
            新增明細
          </Button>
        )}
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table className="detail-table">
          <thead>
            <tr>
              <th style={{ width: 40 }} data-contract-field="fj511_02">#</th>
              <th style={{ width: 120 }} data-contract-field="fj511_11">產品代號</th>
              <th style={{ width: 80 }} data-contract-field="fj511_12">色號</th>
              <th style={{ width: 100 }} data-contract-field="fj511_13">數量</th>
              <th style={{ width: 100 }} data-contract-field="fj511_14">單價</th>
              <th style={{ width: 120 }} data-contract-field="fj511_15">金額</th>
              {isEditing && <th style={{ width: 50 }}>操作</th>}
            </tr>
          </thead>
          <tbody>
            {details.length === 0 && (
              <tr>
                <td colSpan={isEditing ? 7 : 6} style={{ textAlign: 'center', color: '#999', padding: 24 }}>
                  尚無採購明細
                </td>
              </tr>
            )}
            {details.map((d, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>
                  <input
                    type="text"
                    maxLength={12}
                    disabled={!isEditing}
                    value={d.fj511_11 || ''}
                    onChange={e => onDetailChange(idx, 'fj511_11', e.target.value)}
                    style={{ width: '100%' }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    maxLength={3}
                    disabled={!isEditing}
                    value={d.fj511_12 || ''}
                    onChange={e => onDetailChange(idx, 'fj511_12', e.target.value)}
                    style={{ width: '100%' }}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.01"
                    disabled={!isEditing}
                    value={d.fj511_13 ?? 0}
                    onChange={e => onDetailChange(idx, 'fj511_13', parseFloat(e.target.value) || 0)}
                    style={{ width: '100%' }}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.01"
                    disabled={!isEditing}
                    value={d.fj511_14 ?? 0}
                    onChange={e => onDetailChange(idx, 'fj511_14', parseFloat(e.target.value) || 0)}
                    style={{ width: '100%' }}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.01"
                    disabled={true}
                    value={((d.fj511_13 ?? 0) * (d.fj511_14 ?? 0)).toFixed(2)}
                    style={{ width: '100%' }}
                  />
                </td>
                {isEditing && (
                  <td>
                    <Popconfirm title="確定刪除此明細?" onConfirm={() => onDelete(idx)}>
                      <Button type="link" danger size="small" icon={<DeleteOutlined />} />
                    </Popconfirm>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Tab2Details;
